// List of preferred quote token symbols, in order of preference.
export const PREFERRED_QUOTE_SYMBOLS: string[] = [
  'USDC',
  'USDT',
  'USDS',
  'DAI',
  'EURC',
  'ETH',
  'cbBTC',
];

/**
 * Determines the symbol of the preferred quote token from a pair of token symbols.
 * The preference is based on a predefined list of token symbols.
 * If neither token is in the preferred list, the token with the lexicographically larger symbol is chosen as the quote.
 *
 * @param symbol0 The symbol of the first token.
 * @param symbol1 The symbol of the second token.
 * @returns The symbol of the token that should be treated as the quote currency.
 */
export function isToken0PreferredQuoteToken(symbol0: string, symbol1: string): boolean {
  let preference0 = PREFERRED_QUOTE_SYMBOLS.indexOf(symbol0);
  let preference1 = PREFERRED_QUOTE_SYMBOLS.indexOf(symbol1);
  preference0 = preference0 === -1 ? PREFERRED_QUOTE_SYMBOLS.length : preference0;
  preference1 = preference1 === -1 ? PREFERRED_QUOTE_SYMBOLS.length : preference1;

  return preference0 <= preference1;
}

/**
 * Orders currencies for a pool to show base token first, quote token second.
 * This ensures consistent ordering between pool names and currency displays.
 *
 * @param currencies Array of exactly 2 currencies to order
 * @returns Array with [baseToken, quoteToken] ordering
 */
export function getOrderedCurrenciesForPool<T extends { displaySymbol: string }>(
  currencies: T[],
): T[] {
  if (currencies.length !== 2) return currencies;

  const token0AsPreferredQuoteToken = isToken0PreferredQuoteToken(
    currencies[0].displaySymbol,
    currencies[1].displaySymbol,
  );

  // baseToken first, quoteToken second (same logic as usePoolsInfo)
  const baseToken = token0AsPreferredQuoteToken ? currencies[1] : currencies[0];
  const quoteToken = token0AsPreferredQuoteToken ? currencies[0] : currencies[1];

  return [baseToken, quoteToken];
}
